'use client';

import { useFindCategoriesQuery } from '../../query/useFindFacetsQuery';
import { useFindSectionsQuery } from '../../query/useFindSectionsQuery';
import FlyoutMenuCampaign from './FlyoutMenuCampaign';
import FlyoutMenuCategory from './FlyoutMenuCategory';
import FlyoutMenuSelections from './FlyoutMenuSelections';
import AiStars from '@/components/icons/AiStars';
import {useTranslations} from 'next-intl';
import {Link} from '@/i18n/routing';

function NavBar() {
  const { data: sections } = useFindSectionsQuery();
  const { data: facets } = useFindCategoriesQuery();
  const t = useTranslations();

  return (
    <nav className="container mx-auto flex flex-nowrap items-center gap-3 lg:gap-6 px-4 lg:px-6 xl:px-8 overflow-x-auto">
      {facets?.categories.map((category) => (
        <FlyoutMenuCategory key={`flyout-${category.id}`} category={category} />
      ))}
      <div className="w-px h-6 bg-greyscale-separator" />
      <FlyoutMenuCampaign campaigns={sections?.campaigns || []} />
      <FlyoutMenuSelections />
      <Link
        // @ts-expect-error
        href={{pathname: '/otto'}}
        className={`block no-underline text-sm lg:text-base font-medium tracking-tight text-greyscale-label py-3 group-hover/flyout:text-greyscale-title border-b-2 hover:border-b-greyscale-body border-b-transparent`}
      >
        <div className="flex items-center gap-1">
          <AiStars width={20} height={15} />
          <span>{t('otto.title')}</span>
        </div>
      </Link>
    </nav>
  );
}

export default NavBar;
